import React from "react";
import OSModuleSubtopic from "../OSModuleSubtopic";

const InterprocessCommunicationSynchronization = () => (
  <OSModuleSubtopic
    title="Inter-process communication, Synchronization - Implementing synchronization primitives (Peterson’s solution, Bakery algorithm, synchronization hardware)"
    videos={[
      "https://www.youtube.com/embed/dJuYKfR8vec",
      "https://www.youtube.com/embed/3Eaw1SSIqRg",
      "https://www.youtube.com/embed/qMQsd7Iy5jo",
      "https://www.youtube.com/embed/CvbaxkhwX3g",
      "https://www.youtube.com/embed/gYCiTtgGR5Q",
      "https://www.youtube.com/embed/9hzoO4hBXFw"
    ]}
    takeaways={[]}
    questions={[
      {
        text: "1) Write the pseudo code of Peterson’s method and analyze with justification each of the output for the below-given scenarios. i) The above table shows the interest of process P0 and P1 to enter the critical section (“True” denotes interested, “False” denotes not interested) and “Turn” denotes which process is currently under execution. Assume initially both processes are not interested to get into the critical section. ii) Also justify whether mutual exclusion and progress is guaranteed for Peterson’s method with an example for each",
         image:"/os_13.png"
      },
      {
        text: "a) Explain the critical section problem in process synchronization focusing on the minimum requirements to be satisfied to resolve the critical section problem. [5 Marks] b) Illustrate a classic software-based solution for the critical section problem. Identify its difficulties in supporting modern computer architecture. Briefly discuss the possible alternatives to overcome the issue.[5 Marks]"
      },
      {
        text: "3) In a modern multi-robot warehouse, robots perform tasks like retrieving items from storage, transporting them to packing areas, and restocking items. These robots often need to access shared storage shelves. To avoid collisions and ensure that only one robot accesses storage aisle at a time, synchronization is needed. Show how Bakery algorithm can be used to ensure safe, fair, and efficient coordination among robots competing for shared resources. Discuss your answer with a neat pseudo code."
      },
      {
        text: "4) Describe Peterson's solution for mutual exclusion. How does it ensure that only one process enters the critical section at a time?"
      },
      {
        text: "5) Compare shared memory and message passing in Interprocess Communication (IPC)."
      }
    ]}
    exampleVideos={[]}
  />
);

export default InterprocessCommunicationSynchronization;
